import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

export function PreviewEmailModalHeader(): JSX.Element {
	return (
		<Box>
			<Heading size="h3" as="h1" sx={{ textAlign: 'center' }} mb={16}>
				<Translate value="corgi.petition_update.preview_modal.title" />
			</Heading>
			<Text as="p" sx={{ textAlign: 'center' }} mb={[16, 40]}>
				<Translate value="corgi.petition_update.preview_modal.description" />
			</Text>
		</Box>
	);
}
